// extracted by mini-css-extract-plugin
module.exports = {"advertisingWrapper":"styles_advertisingWrapper__3EfS9","alignCenter":"styles_alignCenter__21KVp","list":"styles_list__3zRS7"};